import React, { useEffect } from 'react';
import moment from 'moment';

import PropTypes from 'prop-types';
import Header from './Header/Header';
import styles from './index.module.scss';
import Radio from '../Radio/Radio';
import Datepicker from '../Datepicker/Datepicker';
import TimeInput from '../TimeInput';

function Step4({
  setState, getState, size, current, data, handleClose
}) {
  const isASAP = getState('isASAP');

  useEffect(() => {
    const date = getState('date');
    if (!isASAP && !date) {
      setState('date', moment());
    }
  }, [isASAP]);

  const handleDateChange = (date) => {
    setState('date', date);
  };

  const handleTimeChange = (time) => {
    setState('time', time);
  };

  return (
    <div className={styles.wrapper}>
      <Header current={current} size={size} occupation={data.occupation_name} business={data.business_name} handleClose={handleClose} />
      <div className={styles.body}>
        <p className={styles.title}>When do you need the service?</p>
        <div className={styles.options}>
          <Radio
            label={'As soon as possible'}
            checked={isASAP}
            name="isASAP"
            onClick={() => setState('isASAP', true)}
          />
          <Radio
            label={'Schedule an appointment'}
            checked={!isASAP}
            name="isASAP"
            onClick={() => setState('isASAP', false)}
          />
        </div>
        {!isASAP
        && (
          <div className={styles.section}>
            <p className={styles.title}>Appointment date and time</p>
            <div className={styles.options}>
              <Datepicker label="Date" onChange={(v) => handleDateChange(v)} defaultDate={getState('date', '')} />
              <TimeInput
                label={'Time'}
                value={moment(getState('time'))}
                onChange={(v) => handleTimeChange(v)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

Step4.propTypes = {
  data: PropTypes.shape({
    occupation_name: PropTypes.string,
    occupation_id: PropTypes.number,
    business_name: PropTypes.string,
  }),
  setState: PropTypes.func,
  getState: PropTypes.func,
  current: PropTypes.number,
  size: PropTypes.number,
  handleClose: PropTypes.func,
};

export default Step4;
